import { Grid } from 'antd';

export function useIsMobile() {
  const screens = Grid.useBreakpoint(); // { xs, sm, md, lg, xl, xxl }
  const isMobile = screens.lg === false;      // treat < lg as mobile
  const isDesktop = screens.lg === true;      // >= lg

  return { screens, isMobile, isDesktop };
}
